export const mutations = {
  SET_STAT: (state, data) => {
    state.statistics = data;
  },
};